import en from './locales/en.json';
import de from './locales/de.json';

export const paymentsApprovalLocales = {
  en: { paymentsApproval: en },
  de: { paymentsApproval: de },
};

export { default as PaymentsApproval } from './PaymentsApproval.vue';
export * from './components';
export * from './payments-approval.routes';
